import { toast } from "sonner";

// Standardized toast configurations
export const errorToast = (message: string, options?: Parameters<typeof toast.error>[1]) => {
  return toast.error(message, {
    duration: 6000, // Longer duration for errors
    dismissible: true, // Always allow users to dismiss
    ...options
  });
};

export const successToast = (message: string, options?: Parameters<typeof toast.success>[1]) => {
  return toast.success(message, {
    duration: 4000, 
    dismissible: true,
    ...options
  });
};

export const infoToast = (message: string, options?: Parameters<typeof toast.info>[1]) => {
  return toast.info(message, {
    duration: 3000,
    dismissible: true,
    ...options
  });
};
